<p-dialog
  header="Odometer Image"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '650px' }"
  closable="true"
>
  <div class="ui-grid ui-grid-responsive ui-fluid">
    <div class="p-2">
      <div *ngIf="imageSource">
        <img src="{{ imageSource }}" height="610px" width="610px" alt="" />
      </div>
    </div>
  </div>
</p-dialog>
